import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

import options from '~/plugins/formulate.config.js'

Vue.use(VueFormulate, options)
